export default {
  CAPITAL_DECREASE: 'capitalDecrease',
  CAPITAL_INCREASE: 'capitalIncrease',
  CONSTITUTION: 'constitution',
  DIVIDENDS_DISTRIBUTION: 'dividendsDistribution',
  DONATION: 'donation',
  HERITAGE: 'heritage',
  RECLASSIFICATION: 'reclassification',
  RENUMERATION: 'renumeration',
  SELL_PARTICIPATION: 'sellParticipation',
  SPLIT: 'split',
  CONTRIBUTION: 'contribution',
  ENDORSEMENT: 'endorsement',
  TRANSMISSION: 'transmission',
};
